import { API_BASE_URL } from '../../../lib/config'
import { ChatModelVisibilityEditor } from './ChatModelVisibilityEditor'

export function ModelConfigurationSection() {
  const base = `${API_BASE_URL}admin/model-configuration`
  return (
    <ChatModelVisibilityEditor
      title="Model configuration"
      description="Turn models off to hide them from the chat model picker for all users who do not have personal overrides. Users already on a disabled model are moved to an available model when they open chat. At least one model must stay on."
      getUrl={base}
      putUrl={base}
    />
  )
}
